module.exports = __webpack_public_path__ + "static/media/submit-notes.78089236.svg";